import {
  acquisitionMappings,
  otherMappings,
  tradeInMappings,
  underwritingMappings,
} from './urlMappings';

export const getVendorIdByUrl = (url: string) => {
  const mappings = [];
  const acquisition = acquisitionMappings(url);
  const trades = tradeInMappings(url);
  const underwriting = underwritingMappings(url);
  const other = otherMappings(url);

  mappings.push(...acquisition);
  mappings.push(...trades);
  mappings.push(...underwriting);
  mappings.push(...other);

  for (const re of mappings) {
    // below is a direct import from old ChatAI. Don't want to alter.
    // @ts-ignore // eslint-disable-next-line
    if (re[0].test(url)) {
      return String(re[1]);
    }
  }
  return undefined;
};
